/*
  File: assets/available-decks.js
*/

(function () {
  var availableDecksPayload = null;

  var availableDecksExternalBaseSubtotalCents = null;
  var availableDecksLastDeckSubtotalCents = 0;
  var availableDecksLastWrittenSubtotalCents = null;
  var availableDecksIsWritingSubtotal = false;
  var availableDecksSubtotalObserver = null;
  var availableDecksSubtotalInterval = null;
  var availableDecksSubtotalDebounce = null;

  var availableDecksUserAddIntentUntil = 0;
  var availableDecksLastAdd = {
    sig: '',
    ts: 0
  };

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function markUserAddIntent() {
    availableDecksUserAddIntentUntil = Date.now() + 3000;
  }

  function clearUserAddIntent() {
    availableDecksUserAddIntentUntil = 0;
  }

  function hasUserAddIntent() {
    return Date.now() < availableDecksUserAddIntentUntil;
  }

  function findProductForm() {
    var forms = Array.prototype.slice.call(
      document.querySelectorAll('form[action*="/cart/add"], form[action*="cart/add"]')
    );

    if (!forms.length) return null;

    var withSubmit = null;

    for (var i = 0; i < forms.length; i++) {
      if (
        forms[i].querySelector(
          'button[type="submit"], input[type="submit"], button[name="add"], [data-add-to-cart]'
        )
      ) {
        withSubmit = forms[i];
        break;
      }
    }

    return withSubmit || forms[0];
  }

  function safeJsonParse(text) {
    try {
      return JSON.parse(text);
    } catch (e) {
      return null;
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .split('&').join('&amp;')
      .split('<').join('&lt;')
      .split('>').join('&gt;')
      .split('"').join('&quot;')
      .split("'").join('&#039;');
  }

  function getRequestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && input.url) return input.url;
    return '';
  }

  function isCartAddUrl(url) {
    return (
      typeof url === 'string' &&
      (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/add.js') !== -1)
    );
  }

  function isAvailableDecksRequest(headers) {
    if (!headers) return false;

    if (typeof headers.get === 'function') {
      return headers.get('X-Available-Decks') === '1';
    }

    return headers['X-Available-Decks'] === '1' || headers['x-available-decks'] === '1';
  }

  function getBox() {
    return document.querySelector('[data-available-decks]');
  }

  function getSelectedDeckInputs() {
    var box = getBox();
    if (!box) return [];

    return Array.prototype.slice.call(
      box.querySelectorAll('input.available-decks__checkbox:checked:not(:disabled)')
    );
  }

  function getSelectedDeckVariantIds() {
    var selected = getSelectedDeckInputs();
    var ids = [];

    for (var i = 0; i < selected.length; i++) {
      var n = Number(selected[i].value);

      if (isFinite(n) && n > 0) {
        ids.push(n);
      }
    }

    return ids;
  }

  function getSelectedDeckTitles() {
    var selected = getSelectedDeckInputs();
    var titles = [];

    for (var i = 0; i < selected.length; i++) {
      var title = selected[i].getAttribute('data-deck-title');

      if (title) {
        titles.push(title);
      }
    }

    return titles;
  }

  function getSelectedDeckSubtotalCents() {
    var selected = getSelectedDeckInputs();
    var total = 0;

    for (var i = 0; i < selected.length; i++) {
      var n = Number(selected[i].getAttribute('data-deck-price-cents'));

      if (isFinite(n) && n > 0) {
        total += n;
      }
    }

    return total;
  }

  function showDeckError(message) {
    var box = getBox();
    if (!box) return;

    var errorEl = box.querySelector('[data-available-decks-error]');
    if (!errorEl) return;

    errorEl.textContent = message || 'Please select at least one available deck.';
    errorEl.style.display = '';
  }

  function hideDeckError() {
    var box = getBox();
    if (!box) return;

    var errorEl = box.querySelector('[data-available-decks-error]');
    if (!errorEl) return;

    errorEl.style.display = 'none';
    errorEl.textContent = 'Please select at least one available deck.';
  }

  function forceClosePanel() {
    var box = getBox();
    if (!box) return;

    var toggle = box.querySelector('[data-available-decks-toggle]');
    var panel = box.querySelector('[data-available-decks-panel]');

    if (panel) {
      panel.hidden = true;
    }

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }

    box.classList.remove('available-decks--open');
  }

  function openPanel() {
    var box = getBox();
    if (!box) return;

    var toggle = box.querySelector('[data-available-decks-toggle]');
    var panel = box.querySelector('[data-available-decks-panel]');

    if (!toggle || !panel) return;

    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    box.classList.add('available-decks--open');
  }

  function updateToggleText() {
    var box = getBox();
    if (!box) return;

    var textEl = box.querySelector('[data-available-decks-toggle-text]');
    if (!textEl) return;

    var titles = getSelectedDeckTitles();

    if (!titles.length) {
      textEl.textContent = 'Select available decks';
      return;
    }

    if (titles.length === 1) {
      textEl.textContent = titles[0];
      return;
    }

    textEl.textContent = titles.length + ' decks selected';
  }

  function getMainVariantIdFromResponse(data) {
    return (
      (data && data.id && Number(data.id)) ||
      (data && data.items && data.items[0] && Number(data.items[0].id)) ||
      null
    );
  }

  function parseMoneyToCents(text) {
    var raw = String(text || '');
    var cleaned = raw.replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    var value = Number(cleaned);

    if (!isFinite(value)) return null;

    return Math.round(value * 100);
  }

  function formatMoney(cents) {
    var value = Number(cents || 0);
    var format =
      (availableDecksPayload && availableDecksPayload.moneyFormat) ||
      '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;

      if (isNaN(number) || number == null) return '0';

      number = (number / 100).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';
    var money = '';

    switch (placeholder) {
      case 'amount':
        money = formatWithDelimiters(value, 2);
        break;
      case 'amount_no_decimals':
        money = formatWithDelimiters(value, 0);
        break;
      case 'amount_with_comma_separator':
        money = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        money = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        money = formatWithDelimiters(value, 2, "'", '.');
        break;
      default:
        money = formatWithDelimiters(value, 2);
    }

    return format.replace(placeholderRegex, money);
  }

  function getSubtotalElement() {
    return document.querySelector('.sg-pro-subtotal-span');
  }

  function readDisplayedSubtotalCents() {
    var el = getSubtotalElement();
    if (!el) return null;

    return parseMoneyToCents(el.textContent);
  }

  function writeDisplayedSubtotalCents(cents) {
    var el = getSubtotalElement();
    if (!el) return;

    availableDecksIsWritingSubtotal = true;
    availableDecksLastWrittenSubtotalCents = cents;

    el.setAttribute('data-available-decks-written-total', String(cents));
    el.textContent = formatMoney(cents);

    window.setTimeout(function () {
      availableDecksIsWritingSubtotal = false;
    }, 150);
  }

  function applySelectedDeckSubtotal(reason) {
    var selectedDeckSubtotalCents = getSelectedDeckSubtotalCents();
    var domCents = readDisplayedSubtotalCents();

    if (domCents === null) return;

    if (selectedDeckSubtotalCents <= 0) {
      if (
        availableDecksLastWrittenSubtotalCents !== null &&
        domCents === availableDecksLastWrittenSubtotalCents
      ) {
        availableDecksExternalBaseSubtotalCents = Math.max(
          domCents - availableDecksLastDeckSubtotalCents,
          0
        );

        writeDisplayedSubtotalCents(availableDecksExternalBaseSubtotalCents);
      } else {
        availableDecksExternalBaseSubtotalCents = domCents;
        availableDecksLastWrittenSubtotalCents = domCents;
      }

      availableDecksLastDeckSubtotalCents = 0;
      stopSubtotalEnforcerIfNoSelection();
      return;
    }

    if (
      availableDecksLastWrittenSubtotalCents !== null &&
      domCents === availableDecksLastWrittenSubtotalCents
    ) {
      if (availableDecksExternalBaseSubtotalCents === null) {
        availableDecksExternalBaseSubtotalCents = Math.max(
          domCents - availableDecksLastDeckSubtotalCents,
          0
        );
      }
    } else {
      availableDecksExternalBaseSubtotalCents = domCents;
    }

    if (availableDecksExternalBaseSubtotalCents === null) {
      availableDecksExternalBaseSubtotalCents = domCents;
    }

    availableDecksLastDeckSubtotalCents = selectedDeckSubtotalCents;

    writeDisplayedSubtotalCents(
      availableDecksExternalBaseSubtotalCents + selectedDeckSubtotalCents
    );
  }

  function applySelectedDeckSubtotalSoon(delay) {
    if (availableDecksSubtotalDebounce) {
      window.clearTimeout(availableDecksSubtotalDebounce);
    }

    availableDecksSubtotalDebounce = window.setTimeout(function () {
      availableDecksSubtotalDebounce = null;
      applySelectedDeckSubtotal('debounced');
    }, delay == null ? 150 : delay);
  }

  function startSubtotalEnforcer() {
    if (availableDecksSubtotalInterval) return;

    availableDecksSubtotalInterval = window.setInterval(function () {
      var selectedDeckSubtotalCents = getSelectedDeckSubtotalCents();

      if (selectedDeckSubtotalCents <= 0) {
        stopSubtotalEnforcerIfNoSelection();
        return;
      }

      if (availableDecksIsWritingSubtotal) return;

      var domCents = readDisplayedSubtotalCents();
      if (domCents === null) return;

      if (
        availableDecksLastWrittenSubtotalCents !== null &&
        domCents === availableDecksLastWrittenSubtotalCents
      ) {
        return;
      }

      applySelectedDeckSubtotal('interval');
    }, 250);
  }

  function stopSubtotalEnforcerIfNoSelection() {
    if (getSelectedDeckSubtotalCents() > 0) return;

    if (availableDecksSubtotalInterval) {
      window.clearInterval(availableDecksSubtotalInterval);
      availableDecksSubtotalInterval = null;
    }
  }

  function clearDeckSubtotalFromDisplay() {
    var domCents = readDisplayedSubtotalCents();

    if (domCents === null) return;

    if (
      availableDecksLastWrittenSubtotalCents !== null &&
      domCents === availableDecksLastWrittenSubtotalCents
    ) {
      availableDecksExternalBaseSubtotalCents = Math.max(
        domCents - availableDecksLastDeckSubtotalCents,
        0
      );
    } else {
      availableDecksExternalBaseSubtotalCents = domCents;
    }

    availableDecksLastDeckSubtotalCents = 0;

    writeDisplayedSubtotalCents(availableDecksExternalBaseSubtotalCents);
  }

  function watchPluginSubtotal() {
    var el = getSubtotalElement();
    if (!el || availableDecksSubtotalObserver) return;

    availableDecksExternalBaseSubtotalCents = readDisplayedSubtotalCents();

    availableDecksSubtotalObserver = new MutationObserver(function () {
      if (availableDecksIsWritingSubtotal) return;

      if (getSelectedDeckSubtotalCents() > 0) {
        applySelectedDeckSubtotalSoon(150);
      } else {
        availableDecksExternalBaseSubtotalCents = readDisplayedSubtotalCents();
        availableDecksLastDeckSubtotalCents = 0;
        availableDecksLastWrittenSubtotalCents = availableDecksExternalBaseSubtotalCents;
        stopSubtotalEnforcerIfNoSelection();
      }
    });

    availableDecksSubtotalObserver.observe(el, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function buildAddonItems(mainVariantId) {
    var selected = getSelectedDeckInputs();

    if (!selected.length) {
      showDeckError('Please select at least one available deck.');
      openPanel();
      return [];
    }

    var items = [];

    for (var i = 0; i < selected.length; i++) {
      var deckVariantId = Number(selected[i].value);

      if (isFinite(deckVariantId) && deckVariantId > 0 && !selected[i].disabled) {
        items.push({
          id: deckVariantId,
          quantity: 1,
          properties: {
            _addon_source: 'walker_deck_accordion',
            _addon_for_variant: String(mainVariantId || '')
          }
        });
      }
    }

    return items;
  }

  function resetDeckSelectionAfterSuccessfulAdd() {
    var box = getBox();
    if (!box) return;

    clearDeckSubtotalFromDisplay();

    var checked = box.querySelectorAll('input.available-decks__checkbox:checked');
    for (var i = 0; i < checked.length; i++) {
      checked[i].checked = false;
    }

    availableDecksLastDeckSubtotalCents = 0;

    updateToggleText();
    hideDeckError();
    forceClosePanel();
    clearUserAddIntent();
    stopSubtotalEnforcerIfNoSelection();

    window.setTimeout(function () {
      hideDeckError();
      forceClosePanel();
    }, 150);

    window.setTimeout(function () {
      hideDeckError();
      forceClosePanel();
    }, 500);
  }

  function renderDeckOptions(box, payload) {
    var listEl = box.querySelector('[data-available-decks-list]');
    if (!listEl) return;

    var maxToShow = Number(payload.maxToShow || 20);
    var list = Array.isArray(payload.availableDecks)
      ? payload.availableDecks.slice(0, maxToShow)
      : [];

    if (!list.length) {
      box.style.display = 'none';
      listEl.innerHTML = '';
      hideDeckError();
      forceClosePanel();
      return;
    }

    box.style.display = '';

    var rows = '';

    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      var inputId = 'available-deck-' + String(item.variantId || i);
      var isAvailable = item.available !== false;

      var imageHtml = item.image
        ? '<a class="available-decks__image-link" href="' +
          escapeHtml(item.url || '#') +
          '">' +
          '<img class="available-decks__image" src="' +
          escapeHtml(item.image) +
          '" alt="' +
          escapeHtml(item.title || 'Available deck') +
          '">' +
          '</a>'
        : '';

      var titleHtml = item.url
        ? '<a class="available-decks__title" href="' +
          escapeHtml(item.url) +
          '">' +
          escapeHtml(item.title || 'Unknown') +
          '</a>'
        : '<span class="available-decks__title">' + escapeHtml(item.title || 'Unknown') + '</span>';

      var skuHtml = item.sku
        ? '<div class="available-decks__sku">SKU: ' + escapeHtml(item.sku) + '</div>'
        : '';

      var priceHtml = item.price
        ? '<div class="available-decks__price">' + escapeHtml(item.price) + '</div>'
        : '';

      var soldOutHtml = isAvailable
        ? ''
        : '<div class="available-decks__sold-out">Out of stock</div>';

      rows +=
        '<div class="available-decks__option' +
        (isAvailable ? '' : ' available-decks__option--disabled') +
        '">' +
        '<input' +
        ' id="' +
        escapeHtml(inputId) +
        '"' +
        ' class="available-decks__checkbox"' +
        ' type="checkbox"' +
        ' name="available_deck_variant_id[]"' +
        ' value="' +
        escapeHtml(item.variantId) +
        '"' +
        ' data-deck-title="' +
        escapeHtml(item.title || 'Unknown') +
        '"' +
        ' data-deck-price-cents="' +
        escapeHtml(item.priceCents || 0) +
        '"' +
        (isAvailable ? '' : ' disabled aria-disabled="true"') +
        ' style="position:absolute!important;left:-9999px!important;top:auto!important;width:1px!important;height:1px!important;opacity:0!important;overflow:hidden!important;pointer-events:none!important;-webkit-appearance:none!important;appearance:none!important;margin:0!important;padding:0!important;border:0!important;"' +
        '>' +
        '<label class="available-decks__label" for="' +
        escapeHtml(inputId) +
        '">' +
        '<span class="available-decks__check" aria-hidden="true"></span>' +
        imageHtml +
        '<span class="available-decks__content">' +
        titleHtml +
        skuHtml +
        priceHtml +
        soldOutHtml +
        '</span>' +
        '</label>' +
        '</div>';
    }

    listEl.innerHTML = rows;

    var checkboxes = Array.prototype.slice.call(
      box.querySelectorAll('input.available-decks__checkbox:not(:disabled)')
    );

    for (var c = 0; c < checkboxes.length; c++) {
      checkboxes[c].addEventListener('change', function () {
        clearUserAddIntent();
        hideDeckError();
        updateToggleText();

        applySelectedDeckSubtotal('deck-selection');

        if (getSelectedDeckSubtotalCents() > 0) {
          startSubtotalEnforcer();
        } else {
          stopSubtotalEnforcerIfNoSelection();
        }
      });
    }

    hideDeckError();
    forceClosePanel();
  }

  function bindUiEvents(box, productForm) {
    var toggle = box.querySelector('[data-available-decks-toggle]');

    if (toggle && toggle.dataset.availableDecksToggleBound !== 'true') {
      toggle.dataset.availableDecksToggleBound = 'true';

      toggle.addEventListener('click', function () {
        clearUserAddIntent();
        hideDeckError();

        var panel = box.querySelector('[data-available-decks-panel]');
        if (!panel) return;

        if (panel.hidden) {
          openPanel();
        } else {
          forceClosePanel();
        }
      });
    }

    if (box.dataset.availableDecksOutsideClickBound !== 'true') {
      box.dataset.availableDecksOutsideClickBound = 'true';

      document.addEventListener('click', function (event) {
        var currentBox = getBox();
        if (!currentBox) return;

        if (!currentBox.contains(event.target)) {
          forceClosePanel();
        }
      });
    }

    if (productForm && productForm.dataset.availableDecksClickBound !== 'true') {
      productForm.dataset.availableDecksClickBound = 'true';

      productForm.addEventListener(
        'click',
        function (event) {
          var target = event.target;

          if (
            target &&
            target.closest &&
            target.closest('button[type="submit"], input[type="submit"], button[name="add"], [data-add-to-cart]')
          ) {
            markUserAddIntent();
          }
        },
        true
      );
    }

    if (productForm && productForm.dataset.availableDecksRequiredBound !== 'true') {
      productForm.dataset.availableDecksRequiredBound = 'true';

      productForm.addEventListener(
        'submit',
        function (event) {
          var currentBox = getBox();

          if (!currentBox || currentBox.style.display === 'none') return;

          markUserAddIntent();

          if (!getSelectedDeckInputs().length) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showDeckError('Please select at least one available deck.');
            openPanel();
            return false;
          }
        },
        true
      );
    }
  }

  function init() {
    var box = getBox();
    if (!box) return false;

    if (box.dataset.availableDecksInit === 'true') {
      hideDeckError();
      forceClosePanel();
      return true;
    }

    box.dataset.availableDecksInit = 'true';

    var payloadEl = box.querySelector('[data-available-decks-payload]');

    if (!payloadEl) {
      box.style.display = 'none';
      return false;
    }

    var payload = safeJsonParse(payloadEl.textContent);
    availableDecksPayload = payload;

    if (!payload) {
      box.style.display = 'none';
      return false;
    }

    var productForm = findProductForm();

    if (!productForm) {
      box.style.display = 'none';
      return false;
    }

    renderDeckOptions(box, payload);
    bindUiEvents(box, productForm);
    watchPluginSubtotal();

    hideDeckError();
    forceClosePanel();

    window.__availableDecks = window.__availableDecks || {};

    window.__availableDecks.getAddonItems = function (mainVariantId) {
      return buildAddonItems(mainVariantId);
    };

    return true;
  }

  function wrapFetchOnce() {
    if (window.__availableDecksFetchWrapped) return;

    window.__availableDecksFetchWrapped = true;

    var originalFetch = window.fetch;

    function getSignature(mainVariantId) {
      try {
        var ids = getSelectedDeckVariantIds();

        ids.sort(function (a, b) {
          return a - b;
        });

        return String(mainVariantId || '') + '|' + ids.join(',');
      } catch (e) {
        return String(mainVariantId || '') + '|err';
      }
    }

    window.fetch = function (input, initArg) {
      try {
        var preUrl = getRequestUrl(input);
        var preIsAdd = isCartAddUrl(preUrl);
        var preHeaders = initArg && initArg.headers ? initArg.headers : null;
        var preMarked = isAvailableDecksRequest(preHeaders);
        var currentBox = getBox();

        if (
          preIsAdd &&
          !preMarked &&
          currentBox &&
          currentBox.style.display !== 'none' &&
          hasUserAddIntent() &&
          !getSelectedDeckInputs().length
        ) {
          showDeckError('Please select at least one available deck.');
          openPanel();

          return Promise.resolve(
            new Response(
              JSON.stringify({
                status: 422,
                message: 'Please select at least one available deck.'
              }),
              {
                status: 422,
                headers: {
                  'Content-Type': 'application/json'
                }
              }
            )
          );
        }
      } catch (e) {}

      return originalFetch.apply(this, arguments).then(function (res) {
        try {
          var url = getRequestUrl(input);
          var isAdd = isCartAddUrl(url);
          var headers = initArg && initArg.headers ? initArg.headers : null;
          var marked = isAvailableDecksRequest(headers);

          if (
            isAdd &&
            !marked &&
            res &&
            res.ok &&
            hasUserAddIntent() &&
            window.__availableDecks &&
            typeof window.__availableDecks.getAddonItems === 'function'
          ) {
            var clone = res.clone();

            clone
              .text()
              .then(function (text) {
                var data = safeJsonParse(text);
                var mainVariantId = getMainVariantIdFromResponse(data);

                if (!mainVariantId) return;

                var addonItems = window.__availableDecks.getAddonItems(mainVariantId);

                if (!addonItems || !addonItems.length) return;

                var sig = getSignature(mainVariantId);
                var now = Date.now();

                if (availableDecksLastAdd.sig === sig && now - availableDecksLastAdd.ts < 4000) {
                  return;
                }

                availableDecksLastAdd.sig = sig;
                availableDecksLastAdd.ts = now;

                originalFetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Available-Decks': '1'
                  },
                  body: JSON.stringify({
                    items: addonItems
                  })
                })
                  .then(function (addonRes) {
                    if (addonRes && addonRes.ok) {
                      resetDeckSelectionAfterSuccessfulAdd();
                    }
                  })
                  ['catch'](function () {});
              })
              ['catch'](function () {});
          }
        } catch (e) {}

        return res;
      });
    };
  }

  function runAll() {
    init();
    wrapFetchOnce();
    watchPluginSubtotal();
  }

  ready(runAll);

  document.addEventListener('shopify:section:load', runAll);
  document.addEventListener('shopify:section:reorder', runAll);
  document.addEventListener('shopify:section:select', runAll);
})();